"use client";

interface AlanaLogoProps {
  variant?: "full" | "icon";
  className?: string;
  white?: boolean;
  /** Override bag fill color — defaults to coral #ff8086 */
  color?: string;
}

export function AlanaLogo({
  variant = "full",
  className = "",
  white = false,
  color = "#ff8086",
}: AlanaLogoProps) {
  if (variant === "icon") {
    return (
      <svg
        viewBox="0 0 250 250"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fill={color}
          d="M165.77,62.74c-.25-.48-.76-.74-1.29-.64l-16.12,2.9c-1.49-3.95-12.33-30.39-34.03-25.52-19.41,4.35-20.82,29.75-20.89,35.41l-18.26,3.29c-.71.13-1.15.83-.94,1.52,1.49,4.95,6.21,24.65,2.16,65.34-.64,7.27-4.62,10.91-4.8,11.61-.02.09-.12.13-.17.21-8.58,13.6-8.43,20.41-8.22,22.03.03.25.14.47.31.65l29.25,31.19c.3.32.74.45,1.16.35l92-22.59c.6-.15.99-.72.91-1.33-1.56-11.58-15.43-113.56-21.08-124.41ZM115.4,45.38c16.97-3.81,26.01,15.21,28.17,20.48l-45.66,8.22c.22-6.17,2.15-25.27,17.49-28.71Z"
        />
        <path
          fill="#fff"
          d="M167.6,168.22l-11.31,1.6-1.6-11.32c-1.1.98-1.4,2.8-2.29,4.18-3.02,4.69-7.92,9.16-13.4,10.71-43.62,12.32-55.7-61.26-6.27-63.02,12.71-.45,28.07,9.74,29.94,22.95l4.94,34.91ZM126.78,120.93c-24.59,6.51-16.41,49.32,10.43,43.24,25.12-5.69,16.85-50.46-10.43-43.24Z"
        />
      </svg>
    );
  }

  const textFill = white ? "#fff" : "#0a0a0a";

  return (
    <svg
      viewBox="0 0 176.22 63.07"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g fill={textFill}>
        <path d="M176.22,46.37h-4.43v-4.43c-1.95,2.57-4.13,4.61-7.51,4.92-16.9,1.53-17.05-26.46,1.45-24.59,5.16.52,10.49,5.31,10.49,10.68v13.42ZM162.87,26c-8.92,1.16-8.92,16.35.18,17.17,11.64,1.05,11.45-18.68-.18-17.17Z" />
        <path d="M77.05,46.37h-4.43v-4.43c-.48.32-.69,1-1.1,1.48-1.41,1.64-3.54,3.08-5.73,3.38-17.41,2.36-18.05-26.54,1.02-24.53,4.9.52,10.24,5.26,10.24,10.43v13.67ZM63.96,26.01c-9.79,1.16-8.98,18.04,1.65,17.16,9.95-.82,9.21-18.45-1.65-17.16Z" />
        <path d="M117.66,46.37h-4.18v-4.43c-2.81,3.66-5.69,5.35-10.45,4.92-10.54-.96-12.92-16.73-4.88-22.36,5.69-3.99,14.6-2.85,18.09,3.49.35.64,1.44,3.17,1.44,3.73v14.65ZM104.55,26c-9.21,1.21-8.84,16.52.19,17.17,11.75.84,11.12-18.65-.19-17.17Z" />
        <path d="M146.45,46.37h-4.43v-15.14c0-.1-.65-1.68-.78-1.93-2.3-4.32-8.88-4.38-11.48-.25-.18.28-1.02,2.27-1.02,2.42v14.9h-4.43v-14.4c0-10.23,15.69-13.36,20.71-4.72.48.83,1.43,3.11,1.43,3.98v15.14Z" />
        <rect x="83.7" y="12.64" width="4.43" height="33.73" />
      </g>
      <g>
        <path
          fill={color}
          d="M37.58,8.74c-.09-.17-.28-.27-.47-.24l-5.9,1.06c-.55-1.45-4.52-11.13-12.46-9.35-7.11,1.59-7.62,10.89-7.65,12.97l-6.69,1.2c-.26.05-.42.31-.34.56.55,1.81,2.27,9.03.79,23.93-.24,2.66-1.69,3.99-1.76,4.25,0,.03-.04.05-.06.08C-.11,48.19-.05,50.68.02,51.28c.01.09.05.17.12.24l10.71,11.42c.11.12.27.16.43.13l33.69-8.27c.22-.05.36-.26.33-.49-.57-4.24-5.65-41.59-7.72-45.56ZM19.14,2.38c6.21-1.39,9.53,5.57,10.32,7.5l-16.72,3.01c.08-2.26.79-9.25,6.41-10.51Z"
        />
        <path
          fill="#fff"
          d="M38.25,47.36l-4.14.59-.59-4.15c-.4.36-.51,1.02-.84,1.53-1.11,1.72-2.9,3.35-4.91,3.92-15.98,4.51-20.4-22.43-2.3-23.08,4.65-.17,10.28,3.57,10.96,8.4l1.81,12.78ZM23.3,30.05c-9,2.38-6.01,18.06,3.82,15.84,9.2-2.09,6.17-18.48-3.82-15.84Z"
        />
      </g>
    </svg>
  );
}
